import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import InlineInput from "@via/components/inputs/inline-input.tsx";
import Table from "@via/components/table/table.tsx";
import { GeoItem } from "common";
import { JSX } from "react";

const columnHelper = createColumnHelper<GeoItem>();

export default function GeoEditableTable({
  geoList,
  total = 0,
  onUpdateGeoItemName,
  onRemoveGeoItem,
}: {
  geoList: GeoItem[];
  total: number;
  onUpdateGeoItemName: (srrId: string, newName: string) => void;
  onRemoveGeoItem: (originalItem: GeoItem) => void;
}): JSX.Element {
  const handleUpdateGeoItemName = (originalItem: GeoItem, newName: string) => {
    onUpdateGeoItemName(originalItem.srrId, newName);
  };

  const handleRemoveGeoItem = (originalItem: GeoItem) => {
    onRemoveGeoItem(originalItem);
  };

  const columns = [
    columnHelper.accessor("name", {
      cell: info => (
        <InlineInput
          value={info.getValue()}
          onBlur={name => {
            handleUpdateGeoItemName(info.row.original, name);
          }}
          inputStyle="w-full mr-5"
        />
      ),
      header: () => <span>Name</span>,
    }),
    columnHelper.accessor("srrId", {
      cell: info => info.getValue(),
      header: () => <span>GEO Accession</span>,
    }),
    columnHelper.accessor("collectionType", {
      cell: info => info.getValue(),
      header: () => <span>Single / Pair</span>,
    }),
    columnHelper.accessor("srrId", {
      cell: info => (
        <button
          onClick={() => handleRemoveGeoItem(info.row.original)}
          className="inline-flex items-center gap-x-1.5 rounded-md bg-red-500 px-2 py-2 text-sm text-white shadow-sm duration-200 ease-in-out hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
          Remove
        </button>
      ),
      header: () => null,
    }),
  ] as Array<ColumnDef<GeoItem>>;

  return (
    <div>
      <Table data={geoList || []} columns={columns} total={total} />
    </div>
  );
}
